import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService {
  controllerUrl: string = 'auth';
  private readonly httpClient: HttpClient = inject(HttpClient);

  checkApiKey(apiKey: Guid): Observable<boolean> {
    return this.httpClient.get<boolean>(`${environment.analysisApiUrl}/${this.controllerUrl}/checkapikey/${apiKey}`);
  }
}
